export type WorkspaceMode = "create" | "join";

export type InviteRoleId = "owner" | "admin" | "negotiator" | "analyst" | "guest";

export interface DemoWelcomeInvite {
  email: string;
  role: InviteRoleId;
}

export interface DemoWelcomeState {
  email: string;
  name: string;
  role: string;
  industry: string;
  mode: WorkspaceMode;
  orgName: string;
  size: string;
  joinCode: string;
  invites: DemoWelcomeInvite[];
  connected: string[];
  connecting: string | null;
}

export const INITIAL_DEMO_WELCOME_STATE: DemoWelcomeState = {
  email: "",
  name: "",
  role: "",
  industry: "",
  mode: "create",
  orgName: "",
  size: "",
  joinCode: "",
  invites: [],
  connected: [],
  connecting: null,
};
